import { AuthUser } from "components/auth/Contracts";
import { ReactElement, ReactNode } from "react";
import { User } from "types/user";
import { UserContext } from "./UserContext";

  interface UserProviderProps {
    children: ReactNode
    user: User | undefined
    authObj: AuthUser | null
  }

  export const UserProvider = (props: UserProviderProps): ReactElement => {
  const { user, children, authObj } = props
  const displayName = (authObj?.given_name ?? "").concat(" ", authObj?.family_name ?? "").trim();
  const isValid = user?.userStatus === "valid";    
  const userId = user?.userId ?? "";
  const isLegacy = authObj?.playerId === undefined ? false : true;
  const clubTag = authObj?.clubTagId ?? "";

  return (
      <UserContext.Provider value={{user, isValid, displayName, isLegacy, userId, clubTag }}>
            {children}
      </UserContext.Provider>
    )
}